import { getApiBaseUrl, getTenantSlugFromHostname } from './api';

function buildHeaders() {
  const headers = {
    'Content-Type': 'application/json',
  };

  const tenantSlug = getTenantSlugFromHostname();
  if (tenantSlug) {
    headers['X-Tenant-Slug'] = tenantSlug;
  }

  return headers;
}

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, value);
  });

  const text = query.toString();
  return text ? `?${text}` : '';
}

async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json')
    ? await response.json().catch(() => ({}))
    : {};

  if (!response.ok) {
    const message = payload?.error || `Request failed (${response.status})`;
    throw new Error(message);
  }

  return payload;
}

async function request(path, options = {}) {
  const response = await fetch(`${getApiBaseUrl()}${path}`, {
    method: options.method || 'GET',
    headers: buildHeaders(),
    credentials: 'include',
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  });

  return parseResponse(response);
}

export const guidesApi = {
  listGuides(params = {}) {
    return request(`/api/guides${buildQuery(params)}`);
  },
  startGuide(guideInstanceId) {
    return request(`/api/guides/${encodeURIComponent(guideInstanceId)}/start`, {
      method: 'POST',
      body: {},
    });
  },
  dismissGuide(guideInstanceId) {
    return request(`/api/guides/${encodeURIComponent(guideInstanceId)}/dismiss`, {
      method: 'POST',
      body: {},
    });
  },
  snoozeGuide(guideInstanceId, snoozedUntil) {
    const body = snoozedUntil ? { snoozedUntil } : {};
    return request(`/api/guides/${encodeURIComponent(guideInstanceId)}/snooze`, {
      method: 'POST',
      body,
    });
  },
  updateStepStatus(guideInstanceId, stepKey, status) {
    return request(`/api/guides/${encodeURIComponent(guideInstanceId)}/steps/${encodeURIComponent(stepKey)}`, {
      method: 'PATCH',
      body: { status },
    });
  },
  executeStepAction(guideInstanceId, stepKey, actionKey, body = {}) {
    return request(
      `/api/guides/${encodeURIComponent(guideInstanceId)}/steps/${encodeURIComponent(stepKey)}/actions/${encodeURIComponent(actionKey)}`,
      {
        method: 'POST',
        body,
      },
    );
  },
};

export default guidesApi;
